import { render, staticRenderFns } from "./IconCloseGray.vue?vue&type=template&id=27406b56&scoped=true&functional=true"
import script from "./IconCloseGray.vue?vue&type=script&lang=js"
export * from "./IconCloseGray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "27406b56",
  null
  
)

export default component.exports